var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text-caption"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{ref:"editable",staticClass:"custom-textarea my-2",attrs:{"contenteditable":""},on:{"input":_vm.onInput,"copy":_vm.handleCopy,"paste":_vm.handlePaste,"cut":_vm.handleCut}})])
}
var staticRenderFns = []

export { render, staticRenderFns }